import postRequest from '../../../postRequest';

/**
 * Post request for ProductType logs.
 *
 * @param {number} siteId Site Id
 * @param {number} page Page count
 * @param {number} size Page size
 */
export default function postSizeMappingLogs(
  siteId,
  page,
  size,
  searchTerm,
  fromDate,
  toDate,

) {
  const fromDateString = fromDate === null ? '' : fromDate;
  const toDateString = toDate === null ? '' : toDate;
  const endpoint = `/oc-data-management/v1/size-mapping/log?siteId=${siteId}&searchTerm=${searchTerm}&fromDate=${fromDateString}&toDate=${toDateString}&Page=${page}&Size=${size}`;
  return new Promise((resolve, reject) => {
    postRequest(endpoint, 'SizeMapping Logs')
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
}
